import { Container } from "pixi.js";
import { PromiseCompletionSource } from "../../shared/async/PromiseCompletionSource";

export abstract class BaseView<T> extends Container {
    protected readonly operationControls: PromiseCompletionSource<T>;

    public constructor(operationControls: PromiseCompletionSource<T>) {
        super();
        this.operationControls = operationControls;
    }

    abstract start(): void;
}
